import React from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function reactMemo<TComponentType extends React.ComponentType<any>>(
  component: TComponentType
): TComponentType {
  return (React.memo(component) as unknown) as TComponentType;
}
